import { render } from "./RewardModel.vue?vue&type=template&id=10d6f268&scoped=true"
const script = {}

import "./RewardModel.vue?vue&type=style&index=0&id=10d6f268&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d6f268"]])

export default __exports__